import { render, staticRenderFns } from "./SpkbAdjust.vue?vue&type=template&id=3bc89730&"
import script from "./SpkbAdjust.vue?vue&type=script&lang=js&"
export * from "./SpkbAdjust.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports